import BaseController from './base_controller'

export default class extends BaseController {
  static targets = ['submitButton', 'vessel', 'particularInput', 'submitWrapper']
  static values = { tbn: Boolean, missingMessage: String }

  connect() {
    this.speedsConsumptionMissing = false
    this.attachInputListeners()
    this.boundAjaxSend = (event) => { if (event.target === this.element) this.setVesselLoading(true) }
    this.boundAjaxComplete = (event) => { if (event.target === this.element) this.setVesselLoading(false) }
    this.element.addEventListener('ajax:send', this.boundAjaxSend)
    this.element.addEventListener('ajax:complete', this.boundAjaxComplete)

    this.element.addEventListener('vessel-form:disableSubmit', () => this.disableSubmit())
    ;['vessel-form:enableSubmit', 'calculator:enableSubmit'].forEach(e => this.element.addEventListener(e, () => this.validateForm()))
    this.element.addEventListener('speeds-consumption:state', (event) => this.handleSpeedsConsumptionState(event))
    this.validateForm()
  }

  disconnect() {
    if (this.boundAjaxSend) {
      this.element.removeEventListener('ajax:send', this.boundAjaxSend)
    }
    if (this.boundAjaxComplete) {
      this.element.removeEventListener('ajax:complete', this.boundAjaxComplete)
    }
    if (this.hasSubmitWrapperTarget) {
      bootstrap.Tooltip.getInstance(this.submitWrapperTarget)?.dispose()
    }
  }

  attachInputListeners() {
    this.element.addEventListener('input', () => this.validateForm())
    this.element.addEventListener('change', () => this.validateForm())
  }

  // Gate the submit button on required particulars and speeds/consumption both being filled.
  validateForm() {
    if (this.validateParticulars() && !this.speedsConsumptionMissing) {
      this.enableSubmit()
    } else {
      this.disableSubmit()
    }
  }

  // Reflects the speeds-consumption controller's completeness state, reported via the "state" event, into this form's own gate.
  handleSpeedsConsumptionState(event) {
    this.speedsConsumptionMissing = event.detail.missing
    this.validateForm()
  }

  // Particulars must all be filled before calculating; highlight empties, list the
  // missing ones by name in the submit button tooltip and report validity. TBN
  // vessels are exempt, mirroring the speeds-consumption required-field handling.
  validateParticulars() {
    if (this.tbnValue || !this.hasParticularInputTarget) {
      this.updateMissingParticularsTooltip([])
      return true
    }
    const missing = []
    this.particularInputTargets.forEach((input) => {
      const empty = input.value.trim() === ''
      input.classList.toggle('field-error', empty)
      if (empty && input.dataset.particularLabel) missing.push(input.dataset.particularLabel)
    })
    this.updateMissingParticularsTooltip(missing)
    return missing.length === 0
  }

  // Surfaces the missing particulars as a hover tooltip on the (disabled) submit button,
  // matching the existing disabled-button tooltip pattern instead of inline copy.
  updateMissingParticularsTooltip(missing) {
    if (!this.hasSubmitWrapperTarget) return
    const message = missing.length === 0 ? '' : `${this.missingMessageValue} ${missing.join(', ')}`
    if (message === this._lastMissingMessage) return
    this._lastMissingMessage = message

    const wrapper = this.submitWrapperTarget
    bootstrap.Tooltip.getInstance(wrapper)?.dispose()
    if (message === '') {
      wrapper.removeAttribute('data-bs-toggle')
      wrapper.removeAttribute('title')
      return
    }
    wrapper.setAttribute('data-bs-toggle', 'tooltip')
    wrapper.setAttribute('title', message)
    new bootstrap.Tooltip(wrapper)
  }

  enableSubmit() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false
    }
  }

  disableSubmit() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
    }
  }

  setVesselLoading(isLoading) {
    if (!this.hasVesselTarget) return

    if (isLoading) {
      this.vesselTarget.setAttribute('disabled', true)
    } else {
      this.vesselTarget.removeAttribute('disabled')
    }
  }
}
